// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1_iO6","cls2":"Timer-cls2_H9c Timer-cls1_iO6","bottom":"Timer-bottom_gnW","top":"Timer-top_srw","topBack":"Timer-topBack_ulu","topBehind":"Timer-topBehind_Vl_"};